
import PendingComp from 'admin/components/application/PendingComp';
import AdminSidebar from 'admin/sidebar/AdminSidebar';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { PendingCompSkeleton } from '../SkeletonPending';
import NoDataImage from '../../../assets/images/nodataImg.png'; // Add the path to your image here
import { ToastContainer, toast } from 'react-toastify';

function Pending() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem('accessTokenAdmin'); // Retrieve token from local storage
      const apiUrl = 'https://backend.washta.com/api/admin/businessBystatus?status=pending'; // Replace with your API endpoint

      try {
        const response = await axios.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setData(response.data.data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);
  const gapBtwColmStyle = data?.length === 0 ?  {
   
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

  } : {};
  const handleAccept = async (id) => {
    const token = localStorage.getItem('accessTokenAdmin'); // Retrieve token from local storage
    const apiUrl = `https://backend.washta.com/api/admin/businessApprove/${id}`; // Replace with your API endpoint for PATCH request

    try {
      const response = await axios.patch(apiUrl, {}, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setData((prevData) => prevData.filter((item) => item._id !== id));
      toast.success("successfully accept this business")
    } catch (err) {
      console.error('Error approving:', err);
    }
  };

  const handleReject = async (id) => {
    const token = localStorage.getItem('accessTokenAdmin'); // Retrieve token from local storage
    const apiUrl = `https://backend.washta.com/api/admin/businessReject/${id}`;

    try {
      const response = await axios.patch(apiUrl, {}, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      toast.success("successfully reject this business")
      setData((prevData) => prevData.filter((item) => item._id !== id));
    } catch (err) {
      console.error('Error rejecting:', err);
    }
  };

  return (
    <div className='mainDiv-all-sideBar'>
      <div className='div-sidebar'>
        <AdminSidebar />
      </div>
      <div className='div-Dashbaord'>
        <h1 className='h1-all-heading'>Pending Applications</h1>
        <div className="dashboard">
          <div className='styles-div' style={{ width: '100%'}}>
            <div className={`gap-btw-colm ${loading ? 'w-full' : ''}`} style={gapBtwColmStyle}>
              {loading ? (
                Array.from(new Array(6)).map((_, index) => (
                  <div key={index} style={{ flex: '1 1 calc(25% - 16px)', marginBottom: '16px' }}>
                    <PendingCompSkeleton />
                  </div>
                ))
              ) : data?.length === 0 ?  (
                <div style={{width:'100%',justifyContent:'center',display:'flex'}}>
                  <img src={NoDataImage} alt="No Data" style={{ maxWidth: '50%', maxHeight: '50%',objectFit:'contain' }} />
                </div>
              ) : (
                data?.map((item, index) => {
                  // Check if username or email are empty
                  if (!item.email || !item.username) {
                    return null; // Skip this item if either username or email is empty
                  }
                
                  return (
                    <div key={index} style={{ flex: '1 1 calc(25% - 16px)' }}>
                    <PendingComp
                    data={item}
                    TextpopupbtnHandle={() => handleAccept(item._id)}
                      RejectHandle={() => handleReject(item._id)}
                      AcceptHandle={() => handleAccept(item._id)}
                      location={item.business?.location}
                      document={item.business?.uploadDocument}
                      show={true}
                      accept="Accept"
                      reject="Reject"
                      ViewDocument="View Documents"
                      name={item?.username}
                      date={item.business?.cratedAt}
                      time={item.business?.cratedAt}
                      email={item.email}
                      valNumber={item.business?.VATNumber}
                      Ceo={item.business?.position}
                      showBtn={false}

                      TextPopupbtnLast="Approve Request"
                    />
                  </div>
                 )
                })
                )}
            </div>
          </div>
        </div>
        <ToastContainer/>
      </div>
    </div>
  );
}

export default Pending;
